export const RouteDefs = {
    messageCenter: {
        path: '/messagecenter',
        header: 'Message Center',
        title: 'Message Center',
    },
    therapistDashboard: {
        path: '/dashboard',
        header: 'Therapist Dashboard',
        title: 'Therapist Dashboard'
    },
    patientCareCenter: {
        path: '/patientcarecenter',
        header: 'Patient Care Center',
        title: 'Patient Care Center'
    },
    reportCenter: {
        path: '/reportcenter',
        header: 'Report Center',
        title: 'Report Center'
    },
    helpCenter: {
        path: '/helpcenter',
        header: 'Help Center',
        title: 'Help Center'
    },
    loginPage: {
        path: '/login',
        header: 'Login',
        title: 'Login'
    },
    search: {
        path: '/search',
        header: 'Search',
        title: 'Search'
    },
    autoLogin: {
        path: '/',
        header: 'Login',
        title: 'Login'
    }

}
